// Same-origin deployment uses an empty origin. A bare '/' must never produce
// '//uploads/...' (which browsers interpret as a different hostname).
export const API_URL = (process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');
export const UPLOADS_URL = `${API_URL}/uploads`;

const config = {
  API_URL,
  UPLOADS_URL,
};

export default config;
